DO.Subscribe('app:ready', function(e, $) {
	'use strict';

	const citationButton = '[data-citation]',
		init = () => {
			const citationButtons = document.querySelectorAll(citationButton);

			citationButtons.forEach((button) => attachEvents(button));
		},
		attachEvents = (scope) => {
			scope.addEventListener('click', function(e) {
				const citation = scope.dataset.citation,
					initialValue = scope.innerHTML;

				e.stopPropagation();
				e.preventDefault();

				navigator.clipboard.writeText(citation);

				scope.classList.add('downloads-small-card__citation-button--show');
				scope.innerHTML = 'Citation Copied';

				setTimeout(() => {
					scope.classList.remove('downloads-small-card__citation-button--show');
					scope.innerHTML = initialValue;
				}, 2000);
			});
		};

	init();
});

const mapObject = document.getElementById('google-map-element');

if (mapObject && typeof google !== 'undefined') {
    async function initMap() {
        const { Map, InfoWindow } = await google.maps.importLibrary('maps');
        const { AdvancedMarkerElement } = await google.maps.importLibrary(
            'marker',
        );

        const mapDataString = mapObject.dataset.googleMap;
        const mapData = JSON.parse(mapDataString);
        const center = {
            lat: parseFloat(mapObject.dataset.latitude),
            lng: parseFloat(mapObject.dataset.longitude)
        };

        const map = new Map(mapObject, {
            center: center,
            zoom: mapObject.clientWidth < 640 ?
                parseInt(mapObject.dataset.mobileZoom) :
                parseInt(mapObject.dataset.zoom),
            mapId: mapObject.dataset.mapId,
        });

        let activeMarkerIndex = null;

        const parser = new DOMParser();
        let markers =[];
        let markerPins = [];
        let markerActivePins = [];
        let infoWindows = [];

        mapData.forEach((item, index) => {
            markerPins[index] = parser.parseFromString(
                '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style="transform: translateY(8px);"><circle cx="8" cy="8" r="8" fill="#F92A81" /></svg>',
                'image/svg+xml'
            ).documentElement;

            markerActivePins[index] = parser.parseFromString(
                '<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" style="transform: translateY(16px);"><rect x="0.5" y="0.5" width="31" height="31" rx="15.5" stroke="#C72267" /><circle cx="16" cy="16" r="12" fill="#C72267" /></svg>',
                'image/svg+xml'
            ).documentElement;

            markers[index] = new AdvancedMarkerElement({
                map,
                position: { lat: parseFloat(item.Latitude), lng: parseFloat(item.Longitude) },
                title: item.Title,
                content: markerPins[index],
            });

            if (item.Title || item.Content) {
                infoWindows[index] = new InfoWindow({
                    content: '<div class="info-window">' +
                        (item.Title ? '<h3>' + item.Title + '</h3>' : '') + (item.Content ? '<p>' + item.Content + '</p>' : '') +
                        '</div>',
                    pixelOffset: new google.maps.Size(0, 16),
                });

                markers[index].addListener('click', function() {
                    if (activeMarkerIndex !== null) {
                        infoWindows[activeMarkerIndex].close();
                        markers[activeMarkerIndex].content = markerPins[activeMarkerIndex];

                        if (activeMarkerIndex === index) {
                            activeMarkerIndex = null
                            return;
                        }
                    }

                    infoWindows[index].open(map, markers[index]);
                    markers[index].content = markerActivePins[index];

                    activeMarkerIndex = index;
                });
            }
        });

        google.maps.event.addListener(map, 'click', function() {
            if (activeMarkerIndex !== null) {
                infoWindows[activeMarkerIndex].close();
                markers[activeMarkerIndex].content = markerPins[activeMarkerIndex];
            }
        });
    };

    initMap();
}

DO.Subscribe('app:ready', function(e, $) {
	'use strict';

	const paginationButton = '[data-pagination-button]';

	/**
	 * Initialize Button actions
	 */
	function init() {
		const button = document.querySelector(paginationButton);

		if (button) {
			button.addEventListener(
				'click',
				function(e) {
					const currentPageUrl = window.location.href,
						url = new URL(currentPageUrl),
						currentLimit = button.dataset.limit;

					url.searchParams.set('limit', parseInt(currentLimit) + 9);

					window.location.href = url.toString();
				}
			);
		}
	}

	init();
});

DO.Subscribe('app:ready', function(e, $) {
	'use strict';

	const tabButtons = '[data-tab-button]',
		tabSections = '[data-tab-section]',
		allTabButtons = document.querySelectorAll(tabButtons),
		allTabSections = document.querySelectorAll(tabSections),
		pageTitle = document.querySelector('[data-tab-section-title]'),
		init = () => {
			if (!allTabSections) {
				return false;
			}

			const headerText = allTabSections[0].dataset.tabSectionTitleContent,
				urlParams = new URLSearchParams(window.location.search),
				tabQueryParam = urlParams.get('tab');

			if (headerText) setHeaderText(headerText);

			allTabButtons.forEach((button) => {
				attachEvents(button);
			});

			if (tabQueryParam) {
				openTabFromQueryParam(tabQueryParam);
			}
		},
		removeActiveClassFromButtons = () => {
			allTabButtons.forEach((button) => {
				button.classList.remove('tabs-section__tab--active');
			});
		},
		showSection = (sectionID) => {
			allTabSections.forEach((section) => {
				section.classList.remove('tabs-section__tab-elements--active');

				if (section.dataset.tabSection === sectionID) {
					setHeaderText(section.dataset.tabSectionTitleContent);
					section.classList.add('tabs-section__tab-elements--active');
				}
			});
		},
		setHeaderText = (text) => {
			if (pageTitle) {
				pageTitle.textContent = text;
			}
		},
		attachEvents = (scope) => {
			scope.addEventListener('click', function(e) {
				const currentTabID = scope.dataset.tabButton;

				e.stopPropagation();
				e.preventDefault();

				removeActiveClassFromButtons();
				showSection(currentTabID);
				scope.classList.add('tabs-section__tab--active');
				updateURLWithTabID(currentTabID);
			});
		},
		openTabFromQueryParam = (tabID) => {
			const tabButton = document.querySelector('[data-tab-button="' + tabID + '"]');

			if (tabButton) {
				tabButton.click();
			}
		},
		updateURLWithTabID = (currentTabID) => {
			const urlParams = new URLSearchParams(window.location.search);
			urlParams.set('tab', currentTabID);

			window.history.replaceState({}, document.title, window.location.pathname + '?' + urlParams.toString());
		};

	if (allTabSections.length !== 0) {
		init();
	}
});

/**
 * Toggles and switches extra js (for accessibility).
 * Uses ../lib/toggles-switches.js from https://github.com/dsurgeons/Toggles-Switches
 */

DO.Subscribe('app:ready', function(e, $) {
	'use strict';

	var focusable = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]',
		focusableNative = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed';

	/**
	 * Initialize Button actions
	 */
	function init() {
		setup($(document));
	}

	/**
	 * Apply setup to our newly loaded area (document, or scope)
	 *
	 * @param scope | DOMObject - the area of the page we are applying this functionality to
	 */
	function setup(scope) {
		// if aria hidden, we shouldn't be able to focus
		scope.find('[aria-hidden="true"]').find(focusable).attr('tabindex', '-1');

		attachEvents(scope);
	}

	/**
	 * If an element has the attribute data-toggle-aria we want to toggle the
	 * aria-hidden attribute of the data-toggle-aria value and the tabindex of
	 * all focusable children.
	 * @param scope | DOMObject
	 */
	function attachAriaHide(scope) {
		var targets = scope.find('[data-toggle-aria]');

		// Set aria hidden and tabindex -1
		targets.on('click', function() {
			var target = $(this).data('toggle-aria'),
				value = $(target).attr('aria-hidden') === 'false' ? 'true' : 'false',
				tabindex = value === 'false' ? '0' : '-1';

			$(target).attr('aria-hidden', value);
			$(target).find(focusable).attr('tabindex', tabindex);
		});
	}

	/**
	 * Attach events
	 * @param scope | DOMObject
	 */
	function attachEvents(scope) {
		attachAriaHide(scope);

		scope.find('[data-contain]').on('click', function(e) {
			e.stopPropagation();
		});

		// make sure we get the order of our events right
		setTimeout(function() {
			keyboardFocus(scope);
		}, 1000);

		if (scope.is(document)) {
			$(document).on('ajaxpages:contentloaded', function(e, data) {
				setup(data.target);
			});
		}
	}

	/**
	 * Allow a focus state that only appears for people using keyboards to navigate
	 * @param scope | DOMObject
	 */
	function keyboardFocus(scope) {
		scope.find(focusable).on('keyup', function(e) {
			$(e.target).addClass('hasfocus');

			if ($(e.target).is(focusableNative)) {
				return;
			}

			// trigger click if this element doesn't usually support click
			if (e.keyCode === 13) {
				e.preventDefault();
				e.stopPropagation();
				$(e.target).trigger('click');
			}
		}).on('blur focusout', function(e) {
			$(e.target).removeClass('hasfocus');
		});
	}

	init();
});
